import { connect } from 'react-redux';
import { disableSubmit } from '../../../../redux/actions/Orders';

const mapStateToProps = state => ({
  disableSubmit: state.mainreducer.disableButtonSubmit,
  location: state.mainreducer.area,
  detailsPageCheck: state.mainreducer.detailsPage,
  locationList: state.mainreducer.locationList,
});

const mapDispatchToProps = dispatch => ({
  disableOrderButton() {
    dispatch(disableSubmit());
  },
});

export default Form => connect(mapStateToProps, mapDispatchToProps)(Form);
